module.exports = __webpack_public_path__ + "static/media/fav_icon.127132e8.png";